import { Center, Portal, Spinner, useDisclosure } from "@chakra-ui/react";
import React, { createContext, FC, memo, ReactNode, useContext } from "react";

const context = createContext<{
  loading: boolean;
  showLoading(): void;
  hideLoading(): void;
}>({
  loading: false,
  showLoading() {},
  hideLoading() {},
});

const { Provider } = context;

export const LoadingOverlayProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <Provider value={{ loading: isOpen, showLoading: onOpen, hideLoading: onClose }}>
      {children}

      <LoadingOverlayConsumer />
    </Provider>
  );
};

const LoadingOverlayConsumer = memo(() => {
  const { loading } = useContext(context);

  if (!loading) return null;

  return (
    <Portal>
      <Center
        position="fixed"
        top={0}
        left={0}
        bg="blackAlpha.600"
        w="100vw"
        h="100vh"
        zIndex="tooltip" // tooltip は Chakra の最大の z-index
      >
        <Spinner emptyColor="gray.200" color="blue.500" size="xl" />
      </Center>
    </Portal>
  );
});

export const useLoading = () => {
  const { showLoading, hideLoading } = useContext(context);

  return {
    showLoading,
    hideLoading,
  };
};
